module.exports = __webpack_public_path__ + "img/icon10.bd436f44.png";